export enum InsightsReportType {
  PERFORMANCE = 'PERFORMANCE',
  OPERATIONS = 'OPERATIONS',
  RATINGS = 'RATINGS',
  SETTLEMENTS = 'SETTLEMENTS',
  MOST_SOLD_ITEMS = 'MOST_SOLD_ITEMS',
}

export enum DataAggregationLevel {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
}

export enum ReportSchedule {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
}

export enum ReportMetricRequirement {
  WOLT_PLUS = 'WOLT_PLUS',
  PICKER_ENABLED = 'PICKER_ENABLED',
}

export type ReportMetric = {
  id: string;
  name: string;
  supportedAggregations: DataAggregationLevel[];
  requires: ReportMetricRequirement[];
};

export enum ScheduleConfigDayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

type InsightReportScheduleConfig = {
  timeOfDay: string;
  dayOfWeek: ScheduleConfigDayOfWeek | null;
  dateOfMonth: number | null;
};

export type InsightReportScheduleOption = {
  type: ReportSchedule;
  schedule: InsightReportScheduleConfig;
};

type InsightReportTemplate = {
  type: InsightsReportType;
  supportedAggregations: DataAggregationLevel[];
  metrics: ReportMetric[];
};

export type InsightReportConfig = {
  reports: InsightReportTemplate[];
  schedules: InsightReportScheduleOption[];
  recipient: string;
};

export type ReportLink = {
  url: string;
  expiryDate: string;
};
